import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAuthenticated, children }): React.ReactElement | null => {
  if (!isAuthenticated) {
    return <Navigate to={process.env.PUBLIC_URL + "/login"} replace />;
  }
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;




